import React, { useEffect } from 'react';
import { useIdentificationContext } from '../../IdentificationContext';
import { ResetPasswordStepForm } from './ResetPasswordStepForm';

interface OnSubmitArgs {
    redirectUrl?: string;
}

export const ResetPasswordStep = () => {
    const { navigateToRedirectUrl, setRedirectUrl, email, setEmail } = useIdentificationContext();

    useEffect(() => {
        const cleanupOnUnmount = () => setEmail('');

        return cleanupOnUnmount;
    }, [setEmail]);

    const onSubmit = ({ redirectUrl }: OnSubmitArgs) => {
        if (redirectUrl) {
            setRedirectUrl(redirectUrl);
        }

        navigateToRedirectUrl();
    };

    return <ResetPasswordStepForm onSubmit={onSubmit} email={email} />;
};
